const dictionary = [
  'aaron',
  'about',
  'above',
  'abuse',
  'acids',
  'acres',
  'actor',
  'acute',
  'adams',
  'added',
  'admin',
  'admit',
  'adobe',
  'adopt',
  'adult',
  'after',
  'again',
  'agent',
  'aging',
  'agree',
  'ahead',
  'aimed',
  'alarm',
  'album',
  'alert',
  'alias',
  'alice',
  'alien',
  'align',
  'alike',
  'alive',
  'allah',
  'allan',
  'allen',
  'allow',
  'alloy',
  'alone',
  'along',
  'alpha',
  'alter',
  'amber',
  'amend',
  'amino',
  'among',
  'angel',
  'anger',
  'angle',
  'angry',
  'anime',
  'annex',
  'annie',
  'apart',
  'apnic',
  'apple',
  'apply',
  'april',
  'areas',
  'arena',
  'argue',
  'arise',
  'armed',
  'armor',
  'array',
  'arrow',
  'aruba',
  'ascii',
  'asian',
  'aside',
  'asked',
  'asset',
  'atlas',
  'audio',
  'audit',
  'autos',
  'avoid',
  'award',
  'aware',
  'awful',
  'babes',
  'bacon',
  'badge',
  'badly',
  'baker',
  'balls',
  'bands',
  'banks',
  'barry',
  'based',
  'bases',
  'basic',
  'basin',
  'basis',
  'batch',
  'baths',
  'beach',
  'beads',
  'beans',
  'bears',
  'beast',
  'beats',
  'began',
  'begin',
  'begun',
  'being',
  'belle',
  'belly',
  'below',
  'belts',
  'bench',
  'berry',
  'betty',
  'bible',
  'bikes',
  'bills',
  'billy',
  'bingo',
  'birds',
  'birth',
  'bitch',
  'black',
  'blade',
  'blair',
  'blake',
  'blame',
  'blank',
  'blast',
  'blend',
  'bless',
  'blind',
  'blink',
  'block',
  'blogs',
  'blond',
  'blood',
  'bloom',
  'blues',
  'board',
  'boats',
  'bobby',
  'bonds',
  'bones',
  'bonus',
  'boobs',
  'books',
  'boost',
  'booth',
  'boots',
  'booty',
  'bored',
  'bound',
  'boxed',
  'boxes',
  'brain',
  'brake',
  'brand',
  'brass',
  'brave',
  'bread',
  'break',
  'breed',
  'brian',
  'brick',
  'bride',
  'brief',
  'bring',
  'broad',
  'broke',
  'brook',
  'brown',
  'bruce',
  'brush',
  'bryan',
  'bucks',
  'buddy',
  'build',
  'built',
  'bunch',
  'bunny',
  'burke',
  'burns',
  'burst',
  'buses',
  'busty',
  'butts',
  'buyer',
  'bytes',
  'cabin',
  'cable',
  'cache',
  'cakes',
  'calif',
  'calls',
  'camel',
  'camps',
  'canal',
  'candy',
  'canon',
  'cards',
  'carey',
  'cargo',
  'carlo',
  'carol',
  'carry',
  'cases',
  'casey',
  'casio',
  'catch',
  'cause',
  'cedar',
  'cells',
  'cents',
  'chain',
  'chair',
  'chaos',
  'charm',
  'chart',
  'chase',
  'cheap',
  'cheat',
  'check',
  'chess',
  'chest',
  'chevy',
  'chick',
  'chief',
  'child',
  'chile',
  'china',
  'chips',
  'choir',
  'chose',
  'chris',
  'chuck',
  'cindy',
  'cisco',
  'cited',
  'civic',
  'civil',
  'claim',
  'clara',
  'clark',
  'class',
  'clean',
  'clear',
  'clerk',
  'click',
  'cliff',
  'climb',
  'clips',
  'clock',
  'clone',
  'close',
  'cloth',
  'cloud',
  'clubs',
  'coach',
  'coast',
  'cocks',
  'codes',
  'cohen',
  'coins',
  'colin',
  'colon',
  'color',
  'combo',
  'comes',
  'comic',
  'condo',
  'congo',
  'const',
  'coral',
  'corps',
  'costa',
  'costs',
  'could',
  'count',
  'court',
  'cover',
  'crack',
  'craft',
  'craig',
  'craps',
  'crash',
  'crazy',
  'cream',
  'creek',
  'crest',
  'crime',
  'crops',
  'cross',
  'crowd',
  'crown',
  'crude',
  'cubic',
  'curve',
  'cyber',
  'cycle',
  'czech',
  'daddy',
  'daily',
  'dairy',
  'daisy',
  'dance',
  'danny',
  'dated',
  'dates',
  'david',
  'davis',
  'deals',
  'dealt',
  'death',
  'debug',
  'debut',
  'decor',
  'delay',
  'delhi',
  'delta',
  'dense',
  'depot',
  'depth',
  'derby',
  'derek',
  'devel',
  'devil',
  'devon',
  'diana',
  'diane',
  'diary',
  'dicke',
  'dicks',
  'diego',
  'diffs',
  'digit',
  'dildo',
  'dirty',
  'disco',
  'discs',
  'disks',
  'dodge',
  'doing',
  'dolls',
  'donna',
  'donor',
  'doors',
  'doubt',
  'dover',
  'dozen',
  'draft',
  'drain',
  'drama',
  'drawn',
  'draws',
  'dream',
  'dress',
  'dried',
  'drill',
  'drink',
  'drive',
  'drops',
  'drove',
  'drugs',
  'drums',
  'drunk',
  'dryer',
  'dubai',
  'dutch',
  'dying',
  'dylan',
  'eagle',
  'early',
  'earth',
  'ebony',
  'ebook',
  'eddie',
  'edgar',
  'edges',
  'egypt',
  'eight',
  'elder',
  'elect',
  'elite',
  'ellen',
  'ellis',
  'elvis',
  'emacs',
  'email',
  'emily',
  'empty',
  'ended',
  'endif',
  'enemy',
  'enjoy',
  'enter',
  'entry',
  'epson',
  'equal',
  'error',
  'essay',
  'essex',
  'euros',
  'evans',
  'event',
  'every',
  'exact',
  'exams',
  'excel',
  'exist',
  'extra',
  'faced',
  'faces',
  'facts',
  'fails',
  'fairy',
  'faith',
  'falls',
  'false',
  'fancy',
  'fares',
  'farms',
  'fatal',
  'fatty',
  'fault',
  'favor',
  'fears',
  'feeds',
  'feels',
  'fence',
  'ferry',
  'fever',
  'fewer',
  'fiber',
  'fibre',
  'field',
  'fifth',
  'fifty',
  'fight',
  'filed',
  'files',
  'filme',
  'films',
  'final',
  'finds',
  'fired',
  'fires',
  'firms',
  'first',
  'fixed',
  'fixes',
  'flags',
  'flame',
  'flash',
  'fleet',
  'flesh',
  'float',
  'flood',
  'floor',
  'flour',
  'flows',
  'floyd',
  'fluid',
  'flush',
  'flyer',
  'focal',
  'focus',
  'folks',
  'fonts',
  'foods',
  'force',
  'forge',
  'forms',
  'forth',
  'forty',
  'forum',
  'fotos',
  'found',
  'frame',
  'frank',
  'fraud',
  'fresh',
  'front',
  'frost',
  'fruit',
  'fully',
  'funds',
  'funky',
  'funny',
  'fuzzy',
  'gains',
  'games',
  'gamma',
  'gates',
  'gauge',
  'genes',
  'genre',
  'ghana',
  'ghost',
  'giant',
  'gifts',
  'girls',
  'given',
  'gives',
  'glass',
  'glenn',
  'globe',
  'glory',
  'gnome',
  'goals',
  'going',
  'gonna',
  'goods',
  'gotta',
  'grace',
  'grade',
  'grain',
  'grams',
  'grand',
  'grant',
  'graph',
  'grass',
  'grave',
  'great',
  'greek',
  'green',
  'grill',
  'gross',
  'group',
  'grove',
  'grown',
  'grows',
  'guard',
  'guess',
  'guest',
  'guide',
  'guild',
  'hairy',
  'haiti',
  'hands',
  'handy',
  'happy',
  'harry',
  'haven',
  'hayes',
  'heads',
  'heard',
  'heart',
  'heath',
  'heavy',
  'helen',
  'hello',
  'helps',
  'hence',
  'henry',
  'herbs',
  'highs',
  'hills',
  'hindu',
  'hints',
  'hired',
  'hobby',
  'holds',
  'holes',
  'holly',
  'homes',
  'honda',
  'honey',
  'honor',
  'hoped',
  'hopes',
  'horny',
  'horse',
  'hosts',
  'hotel',
  'hours',
  'house',
  'howto',
  'human',
  'humor',
  'icons',
  'idaho',
  'ideal',
  'ideas',
  'image',
  'inbox',
  'index',
  'india',
  'indie',
  'inner',
  'input',
  'intel',
  'inter',
  'intro',
  'iraqi',
  'irate',
  'irish',
  'isaac',
  'islam',
  'issue',
  'italy',
  'items',
  'ivory',
  'jacob',
  'james',
  'jamie',
  'janet',
  'japan',
  'jason',
  'jeans',
  'jenny',
  'jerry',
  'jesse',
  'jesus',
  'jewel',
  'jimmy',
  'johns',
  'joins',
  'joint',
  'jokes',
  'jones',
  'joyce',
  'judge',
  'juice',
  'julia',
  'julie',
  'karen',
  'karma',
  'kathy',
  'katie',
  'keeps',
  'keith',
  'kelly',
  'kenny',
  'kenya',
  'kerry',
  'kevin',
  'kills',
  'kinda',
  'kinds',
  'kings',
  'kitty',
  'klein',
  'knife',
  'knock',
  'known',
  'knows',
  'kodak',
  'korea',
  'label',
  'labor',
  'laden',
  'lakes',
  'lamps',
  'lance',
  'lands',
  'lanes',
  'lanka',
  'large',
  'larry',
  'laser',
  'later',
  'latex',
  'latin',
  'laugh',
  'laura',
  'layer',
  'leads',
  'learn',
  'lease',
  'least',
  'leave',
  'leeds',
  'legal',
  'lemon',
  'leone',
  'level',
  'lewis',
  'lexus',
  'light',
  'liked',
  'likes',
  'limit',
  'linda',
  'lined',
  'lines',
  'links',
  'linux',
  'lions',
  'lists',
  'lived',
  'liver',
  'lives',
  'lloyd',
  'loads',
  'loans',
  'lobby',
  'local',
  'locks',
  'lodge',
  'logan',
  'logic',
  'login',
  'logos',
  'looks',
  'loops',
  'loose',
  'lopez',
  'lotus',
  'louis',
  'loved',
  'lover',
  'loves',
  'lower',
  'lucas',
  'lucia',
  'lucky',
  'lunch',
  'lycos',
  'lying',
  'lyric',
  'macro',
  'magic',
  'mails',
  'maine',
  'major',
  'maker',
  'makes',
  'males',
  'malta',
  'mambo',
  'manga',
  'manor',
  'maple',
  'march',
  'marco',
  'mardi',
  'maria',
  'marie',
  'mario',
  'marks',
  'mason',
  'match',
  'maybe',
  'mayor',
  'mazda',
  'meals',
  'means',
  'meant',
  'medal',
  'media',
  'meets',
  'menus',
  'mercy',
  'merge',
  'merit',
  'merry',
  'metal',
  'meter',
  'metro',
  'meyer',
  'miami',
  'micro',
  'might',
  'milan',
  'miles',
  'milfs',
  'mills',
  'minds',
  'mines',
  'minor',
  'minus',
  'mixed',
  'mixer',
  'model',
  'modem',
  'modes',
  'money',
  'monte',
  'month',
  'moore',
  'moral',
  'moses',
  'motel',
  'motor',
  'mount',
  'mouse',
  'mouth',
  'moved',
  'moves',
  'movie',
  'mpegs',
  'msgid',
  'multi',
  'music',
  'myers',
  'mysql',
  'nails',
  'naked',
  'named',
  'names',
  'nancy',
  'nasty',
  'naval',
  'needs',
  'nepal',
  'nerve',
  'never',
  'newer',
  'newly',
  'niger',
  'night',
  'nikon',
  'noble',
  'nodes',
  'noise',
  'nokia',
  'north',
  'noted',
  'notes',
  'notre',
  'novel',
  'nurse',
  'nylon',
  'oasis',
  'occur',
  'ocean',
  'offer',
  'often',
  'older',
  'olive',
  'omaha',
  'omega',
  'onion',
  'opens',
  'opera',
  'orbit',
  'order',
  'organ',
  'oscar',
  'other',
  'ought',
  'outer',
  'owned',
  'owner',
  'oxide',
  'ozone',
  'packs',
  'pages',
  'paint',
  'pairs',
  'panel',
  'panic',
  'pants',
  'paper',
  'papua',
  'paris',
  'parks',
  'parts',
  'party',
  'pasta',
  'paste',
  'patch',
  'paths',
  'patio',
  'paxil',
  'peace',
  'pearl',
  'peers',
  'penis',
  'penny',
  'perry',
  'perth',
  'peter',
  'phase',
  'phone',
  'photo',
  'phpbb',
  'piano',
  'picks',
  'piece',
  'pills',
  'pilot',
  'pipes',
  'pitch',
  'pixel',
  'pizza',
  'place',
  'plain',
  'plane',
  'plans',
  'plant',
  'plate',
  'plays',
  'plaza',
  'plots',
  'poems',
  'point',
  'poker',
  'polar',
  'polls',
  'pools',
  'porno',
  'ports',
  'posts',
  'pound',
  'power',
  'press',
  'price',
  'pride',
  'prime',
  'print',
  'prior',
  'prize',
  'probe',
  'promo',
  'proof',
  'proud',
  'prove',
  'proxy',
  'pulse',
  'pumps',
  'punch',
  'puppy',
  'purse',
  'pussy',
  'qatar',
  'queen',
  'query',
  'quest',
  'queue',
  'quick',
  'quiet',
  'quilt',
  'quite',
  'quote',
  'races',
  'racks',
  'radar',
  'radio',
  'raise',
  'rally',
  'ralph',
  'ranch',
  'randy',
  'range',
  'ranks',
  'rapid',
  'rated',
  'rates',
  'ratio',
  'reach',
  'reads',
  'ready',
  'realm',
  'rebel',
  'refer',
  'rehab',
  'relax',
  'relay',
  'remix',
  'renew',
  'reply',
  'reset',
  'retro',
  'rhode',
  'rider',
  'rides',
  'ridge',
  'right',
  'rings',
  'risks',
  'river',
  'roads',
  'robin',
  'robot',
  'rocks',
  'rocky',
  'roger',
  'roles',
  'rolls',
  'roman',
  'rooms',
  'roots',
  'roses',
  'rouge',
  'rough',
  'round',
  'route',
  'rover',
  'royal',
  'rugby',
  'ruled',
  'rules',
  'rural',
  'safer',
  'sagem',
  'saint',
  'salad',
  'salem',
  'sales',
  'sally',
  'salon',
  'samba',
  'samoa',
  'sandy',
  'santa',
  'sanyo',
  'sarah',
  'satin',
  'sauce',
  'saudi',
  'saved',
  'saver',
  'saves',
  'sbjct',
  'scale',
  'scary',
  'scene',
  'scoop',
  'scope',
  'score',
  'scott',
  'scout',
  'screw',
  'scuba',
  'seats',
  'seeds',
  'seeks',
  'seems',
  'sells',
  'sends',
  'sense',
  'serum',
  'serve',
  'setup',
  'seven',
  'shade',
  'shaft',
  'shake',
  'shall',
  'shame',
  'shape',
  'share',
  'shark',
  'sharp',
  'sheep',
  'sheer',
  'sheet',
  'shelf',
  'shell',
  'shift',
  'shine',
  'ships',
  'shirt',
  'shock',
  'shoes',
  'shoot',
  'shops',
  'shore',
  'short',
  'shots',
  'shown',
  'shows',
  'sides',
  'sight',
  'sigma',
  'signs',
  'silly',
  'simon',
  'since',
  'singh',
  'sites',
  'sixth',
  'sized',
  'sizes',
  'skill',
  'skins',
  'skirt',
  'skype',
  'slave',
  'sleep',
  'slide',
  'slope',
  'slots',
  'sluts',
  'small',
  'smart',
  'smell',
  'smile',
  'smith',
  'smoke',
  'snake',
  'socks',
  'solar',
  'solid',
  'solve',
  'songs',
  'sonic',
  'sorry',
  'sorts',
  'souls',
  'sound',
  'south',
  'space',
  'spain',
  'spank',
  'sparc',
  'spare',
  'speak',
  'specs',
  'speed',
  'spell',
  'spend',
  'spent',
  'sperm',
  'spice',
  'spies',
  'spine',
  'split',
  'spoke',
  'sport',
  'spots',
  'spray',
  'squad',
  'stack',
  'staff',
  'stage',
  'stamp',
  'stand',
  'stars',
  'start',
  'state',
  'stats',
  'stays',
  'steal',
  'steam',
  'steel',
  'steps',
  'steve',
  'stick',
  'still',
  'stock',
  'stone',
  'stood',
  'stops',
  'store',
  'storm',
  'story',
  'strap',
  'strip',
  'stuck',
  'study',
  'stuff',
  'style',
  'sucks',
  'sudan',
  'sugar',
  'suite',
  'suits',
  'sunny',
  'super',
  'surge',
  'susan',
  'sweet',
  'swift',
  'swing',
  'swiss',
  'sword',
  'syria',
  'table',
  'tahoe',
  'taken',
  'takes',
  'tales',
  'talks',
  'tamil',
  'tampa',
  'tanks',
  'tapes',
  'tasks',
  'taste',
  'taxes',
  'teach',
  'teams',
  'tears',
  'teddy',
  'teens',
  'teeth',
  'tells',
  'terms',
  'terry',
  'tests',
  'texas',
  'texts',
  'thank',
  'thats',
  'theft',
  'their',
  'theme',
  'there',
  'these',
  'thick',
  'thing',
  'think',
  'third',
  'thong',
  'those',
  'three',
  'throw',
  'thumb',
  'tiger',
  'tight',
  'tiles',
  'timer',
  'times',
  'tions',
  'tired',
  'tires',
  'title',
  'today',
  'token',
  'tokyo',
  'tommy',
  'toner',
  'tones',
  'tools',
  'tooth',
  'topic',
  'total',
  'touch',
  'tough',
  'tours',
  'tower',
  'towns',
  'toxic',
  'trace',
  'track',
  'tract',
  'tracy',
  'trade',
  'trail',
  'train',
  'trans',
  'trash',
  'treat',
  'trees',
  'trend',
  'trial',
  'tribe',
  'trick',
  'tried',
  'tries',
  'trips',
  'trout',
  'truck',
  'truly',
  'trunk',
  'trust',
  'truth',
  'tubes',
  'tulsa',
  'tumor',
  'tuner',
  'tunes',
  'turbo',
  'turns',
  'tvcom',
  'twice',
  'twiki',
  'twins',
  'twist',
  'tyler',
  'types',
  'ultra',
  'uncle',
  'under',
  'union',
  'units',
  'unity',
  'until',
  'upper',
  'upset',
  'urban',
  'usage',
  'users',
  'using',
  'usual',
  'utils',
  'valid',
  'value',
  'valve',
  'vault',
  'vegas',
  'venue',
  'verde',
  'verse',
  'video',
  'views',
  'villa',
  'vinyl',
  'viral',
  'virus',
  'visit',
  'vista',
  'vital',
  'vocal',
  'voice',
  'volvo',
  'voted',
  'votes',
  'vsnet',
  'wages',
  'wagon',
  'wales',
  'walks',
  'walls',
  'wanna',
  'wants',
  'waste',
  'watch',
  'water',
  'watts',
  'waves',
  'wayne',
  'weeks',
  'weird',
  'wells',
  'welsh',
  'wendy',
  'whale',
  'whats',
  'wheat',
  'wheel',
  'where',
  'which',
  'while',
  'white',
  'whole',
  'whore',
  'whose',
  'wider',
  'width',
  'wiley',
  'winds',
  'wines',
  'wings',
  'wired',
  'wires',
  'witch',
  'wives',
  'woman',
  'women',
  'woods',
  'words',
  'works',
  'world',
  'worry',
  'worse',
  'worst',
  'worth',
  'would',
  'wound',
  'wrist',
  'write',
  'wrong',
  'wrote',
  'xanax',
  'xerox',
  'xhtml',
  'yacht',
  'yahoo',
  'yards',
  'years',
  'yeast',
  'yemen',
  'yield',
  'young',
  'yours',
  'youth',
  'yukon',
  'zdnet',
  'zones',
];

export default dictionary;
